<template>
    <div class="h-100 w-100" v-if="!creatingNewIssue">
        <IssuesPage
            v-if="!isUsingSharedLink"
            ref="issues"
            @click=""
            location-type="viewer"
            :is-open="isOpen"
            :project_id="project.id"
            :currentFloorplan="currentFloorplan"
        />
    </div>
    <div class="h-100 w-100" v-else>
        <NewIssueForm
            v-if="!isUsingSharedLink"
            :data="newIssueData"
            @onRequestChangePosition="onRequestChangePosition"
            @cancel="onRequestCancelNewIssue"
            @success="onNewIssueCreated"
        />
    </div>
</template>
<script>
import IssuesPage from '@/views/Project/Issues/IssuesContainer'
import NewIssueForm from './NewIssueForm'

/**
 * @param {Boolean} isOpen
 * @param {Boolean} isUsingSharedLink
 *
 * @param {Object} project
 * @param {Object} currentFloorplan
 *
 * @event onNewIssueRequestChangePosition
 * @event onRequestCancelNewIssue
 * @event onNewIssueCreated
 */

export default {
    name: 'IssuesSidebar',
    components: {
        IssuesPage,
        NewIssueForm,
    },
    props: {
        isOpen: Boolean,
        isUsingSharedLink: Boolean,

        project: Object,
        currentFloorplan: Object,
    },
    data() {
        return {
            creatingNewIssue: false,
            newIssueData: {},
        }
    },
    methods: {
        /**
         * Summary.
         * This method open the new issue form.
         *
         * @param {Object} newIssueData
         */
        openNewIssueForm(newIssueData) {
            this.newIssueData = newIssueData
            this.creatingNewIssue = true
        },

        closeNewIssueForm() {
            this.creatingNewIssue = false
        },

        onRequestChangePosition(data) {
            this.$emit('onNewIssueRequestChangePosition', data)
        },

        onRequestCancelNewIssue() {
            this.creatingNewIssue = false
            this.$emit('onRequestCancelNewIssue')
        },

        onNewIssueCreated(issue) {
            this.creatingNewIssue = false
            this.$emit('onNewIssueCreated', issue)
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/components/360Viewer/Sidebar/generic-sub-sidebar.scss';
@import '@/scss/components/360Viewer/Sidebar/Issues/issues-sidebar.scss';
</style>
